var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallFloatingPurpleBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 176,
    viewBox: "0 0 704 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.148 33.2723C580.322 9.02718 646.96 -11.6368 662.324 8.01934C678.833 29.1406 642.548 20.9833 641.81 29.8684C639.668 55.6521 610.696 50.2577 603.148 33.2723Z",
    fill: "#B5A7CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.012 21.4747C626.307 40.0338 602.861 17.0494 615.381 10.2574C618.567 8.52886 632.64 3.50732 636.294 2.56781C643.353 0.752453 650.68 11.7145 641.788 9.1727C637.141 7.84424 629.711 16.6763 629.012 21.4747Z",
    fill: "#C8BED8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.583 25.2062C604.034 43.2912 610.341 44.6316 618.954 47.2308C627.357 49.7664 642.508 45.3032 641.722 36.5819C641.413 33.1509 642.488 29.0972 645.432 26.8823C648.716 24.4114 664.783 23.2375 663.261 21.6064C661.535 19.7564 642.927 19.0178 641.978 24.6327C641.566 27.073 632.168 38.5775 627.755 39.482C619.522 41.1698 606.781 35.7878 604.264 32.3491C600.883 27.7306 598.703 23.145 598.583 25.2062V25.2062Z",
    fill: "#A090B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.145 8.66215C628.463 8.23787 632.142 5.48819 635.756 5.48819C636.238 5.48819 641.108 6.68102 639.283 7.55532C636.543 8.86715 626.101 11.3955 628.145 8.66215Z",
    fill: "#DBD3E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.006 29.4285C672.07 27.2424 677.309 21.9382 680.832 23.7678C681.688 24.2126 684.635 25.6357 684.418 27.1598C684.284 28.0982 682.504 29.0892 681.834 29.474C679.841 30.6195 678.003 30.5379 676.006 29.4285V29.4285Z",
    fill: "#B5A7CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.115 120.629C170.493 124.175 155.82 138.328 146.517 135.446C144.256 134.745 136.463 132.581 137.209 128.997C137.669 126.79 142.567 123.846 144.412 122.711C149.905 119.331 154.847 118.829 160.115 120.629V120.629Z",
    fill: "#B5A7CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.671 169.389C112.685 172.939 104.719 174.601 101.96 171.522C101.29 170.774 98.9304 168.283 99.889 167.2C100.479 166.533 102.794 166.599 103.671 166.615C106.282 166.661 108.141 167.588 109.671 169.389V169.389Z",
    fill: "#B5A7CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.37 173.306C149.101 174.209 147.007 176.608 145.461 175.854C145.085 175.671 143.794 175.088 143.848 174.417C143.881 174.004 144.613 173.545 144.888 173.367C145.708 172.837 146.491 172.847 147.37 173.306V173.306Z",
    fill: "#B5A7CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74447 141.091C11.5453 143.75 7.70821 149.097 4.32548 146.855C3.50279 146.309 0.688935 144.55 0.654596 142.917C0.633224 141.912 2.05696 140.973 2.59101 140.607C4.18092 139.516 5.81525 139.742 7.74447 141.091Z",
    fill: "#B5A7CB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3846 126.601C51.0583 127.815 49.418 130.175 47.9287 129.149C47.5668 128.9 46.3287 128.094 46.3037 127.365C46.2884 126.916 46.9034 126.507 47.1341 126.347C47.8209 125.872 48.5351 125.984 49.3846 126.601V126.601Z",
    fill: "#B5A7CB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M696.51 10.9351C694.555 10.371 697.687 6.8585 701.309 8.07783C701.993 8.30829 702.523 8.87729 703.042 9.38108C706.242 12.4877 695.823 12.2692 696.51 10.9351V10.9351Z",
    fill: "#B5A7CB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.565 14.4548C673.955 13.9978 674.932 11.1525 676.061 12.1401C676.274 12.3269 676.439 12.7881 676.601 13.196C677.598 15.7126 674.351 15.5357 674.565 14.4548Z",
    fill: "#B5A7CB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallFloatingPurpleBlob);
export default __webpack_public_path__ + "static/media/small-floating-purple-blob.fb5434d377e2694591db7d8a7640b7d1.svg";
export { ForwardRef as ReactComponent };